import { ArrowTopRightIcon, BackpackIcon, CrossCircledIcon, MagnifyingGlassIcon, MixerHorizontalIcon, MixerVerticalIcon } from "@radix-ui/react-icons"
import { Box, Button, Container, Flex, Heading, RadioGroup, Table, Text, TextField } from "@radix-ui/themes"
import React, { ReactNode, useEffect, useMemo, useRef, useState } from "react"
import AppTable from "../../components/controls/tables/AppTable"
import { ScrollArea } from "@radix-ui/themes"
import Pagination from "../../components/common/renders/pagination-render"
import { Select } from "@radix-ui/themes"
import useFetch from "../../core/hooks/useFetch"
import TransactionService from '../../core/services/TransactionService'
import {GetAllTransactionsFormRequest, ITransaction} from '../../core/types/services-types/transaction-types'
import moment from 'moment'
import {toast, ToastContainer} from 'react-toastify'
import { Link } from "react-router"
import FilterTransactionsForm from "../../components/controls/forms/filter-transactions-form"
import { form_to_json } from "../../utils"
export default function Transactions() {
    const [showFilters, setShowFilters] = useState<boolean>(false)
    const [page, setPage] = useState<number>(0)
    const [limit, setLimit] = useState<number>(100)
    const [totalCount, setTotalCount] = useState<number>(0)
    const [transactions, setTransactions] = useState<ITransaction[]>([])
    const refFormFilters = useRef<HTMLFormElement | null>(null)
    const transactionsHeadersTableFormat = useMemo<(string | ReactNode)[]>(() => {
        return [
        "ID",
        "Внешний ID",
        "Отправитель",
        "Тип",
        "Валюта",
        "Комиссия",
        "Количество",
        "Куда",
        "Статус",
        "Сообщение",
        "Тип отправителя",
        "Разделенный платеж",
        "ID Состава Субъекта права",
        "Создано",
        "Обновлено",
        "Действия"
    ]}, [])
    const changeActiveIndex = (index: number) => {
        setPage(index)
    }

    const renderOption = (key: string, value: any) => {
        if(key === 'status') {
            if(value === 'created') {
                return ( 
                <Table.Cell>
                   <Text color='orange'> Создана </Text>
                    </Table.Cell>
                )
            }
            if(value === 'success') {
                return (
                    <Table.Cell>
                   <Text color="grass"> Подтверждена </Text>
                    </Table.Cell>
                
                )
            }
        }
        if(key === 'splitted') {
            if(value === true) {
                return (
                   <Table.Cell>
                   <Text color="grass"> Да </Text>
                    </Table.Cell>
                )
            }
            else {
                return (
                    <Table.Cell>
                   <Text color="grass"> Нет </Text>
                    </Table.Cell>
                )
            }
        }
        if(key === 'createdAt' || key === 'updatedAt') {
           return ( 
            <Table.Cell>
           { moment(value).format("DD.MM.YYYY HH:mm")}
            </Table.Cell>
           )
        }
        if(key === 'message') {
            if(value) {
            return (
                 <Table.Cell>
           {value.substring(0, 40)}...
            </Table.Cell>
            )
        }
        }
        return <Table.Cell>{value}</Table.Cell>
    }

       const onSubmitFilters = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        console.log(refFormFilters.current)
        if (refFormFilters.current) {
            const form = new FormData(refFormFilters.current)
            await fetchTransactionsFilters(form)
        }
    }

    const [fetchRemoveTransaction, isLoadingFetchRemoveTransaction, errorFetchRemoveTransaction, errorsFetchRemoveTransaction] = useFetch(async (id: number | string) => {
        const data = await TransactionService.Delete(id)
        setTransactions(prev => prev.filter(tr => tr.id !== id))
        toast.success(data.message)
    })


    const [fetchTransactionsFilters, isLoadingFetchTransactionsFilters, errorFetchTransactionsFilters, errorsFetchTransactionsFilters] = useFetch(async (form: FormData) => {
        const jsonForm = form_to_json<GetAllTransactionsFormRequest>(form)
        console.log(jsonForm)
        const data = await TransactionService.GetAllFilters(jsonForm.search, jsonForm.minAmount, jsonForm.maxAmount, jsonForm.typeTransaction, jsonForm.currency, jsonForm.dateSort, limit, page)
        setTransactions(data.data)
        setTotalCount(data.count)
    })

    useEffect(() => {
        if(errorFetchTransactionsFilters) toast.error(errorFetchTransactionsFilters)
    }, [errorFetchTransactionsFilters])

  const transactionsTableFormat = useMemo(() => {
    return transactions.map(item => {
        const filterItem = {
            ...item,
            user_id: item.sender.login,
            sender: '',
            receiver: '',
            to: item.receiver?.login ?? ''
        }

        const actions = [
            "Действия",
            <Flex gap={'3'} key={item.id}>
                <Link to={`/transaction/${item.id}`}>
                    <Button variant='surface'>
                        <ArrowTopRightIcon />
                    </Button>
                </Link>
                <Button color="red" onClick={async () => await fetchRemoveTransaction(item.id)}><CrossCircledIcon /></Button>
            </Flex>
        ]

        return Object.entries(filterItem).concat([actions])
    })
}, [transactions])

   
    useEffect(() => {
        if(refFormFilters.current) {
        fetchTransactionsFilters(new FormData(refFormFilters.current))
        }
    }, [page, limit])
    return (
        <Box className="md:p-5 pt-5 bg-zinc-100 min-h-[100vh]">
            <ToastContainer />
            <Box className="bg-zinc-50 rounded-lg shadow-lg p-10">
            <Box className="heading-transactions"> 
           <Heading className="flex items-center justify-center gap-2 p-5">
               <BackpackIcon width={20} height={20} /> Транзакции
           </Heading>
           <Container className="filters mb-5">
             <form ref={refFormFilters} onSubmit={onSubmitFilters}>
                        <FilterTransactionsForm 
                        search
                        min
                        max
                        typeTransaction
                        currency
                        sortDate
                        />
                      <Button>
                            <MixerVerticalIcon />
                            Применить фильтры
                        </Button>
            </form>
           </Container>
           <hr />
           </Box>
           <ScrollArea type="always" scrollbars="both" style={{ height: 650 }} >
            {
            isLoadingFetchTransactionsFilters ? 
            "Загрузка..."
                :
                <AppTable
                headers={transactionsHeadersTableFormat} 
                data={transactionsTableFormat}
                renderOption={renderOption}
                />
            }
           
           </ScrollArea>
           <Container className="p-2"> 
           <Pagination 
           total={totalCount} 
           count={limit} 
           activeIndex={page}
           onChangeIndex={changeActiveIndex}
           />
           </Container>
        </Box>
        </Box>
    )
}